import {Params} from '@feathersjs/feathers'

import {
  DynamicProductionTime,
  DynamicProductionTimeId,
  DynamicProductionTimeWithLinkedProviderInfos,
  ProviderId,
} from '../../types'

import * as feathersService from '../feathers'

export type DynamicProductionTimeRequest = Omit<DynamicProductionTime, 'id'>

export const RESOURCE = 'dynamicProductionTime'

const get = async <Type = DynamicProductionTime>(params?: Params) =>
  feathersService.find<Type>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId) => {
  const parameters = {
    query: {
      provider,
    },
  }
  return get(parameters)
}

export const getWithLinkedProviderInfo = async (params?: Params) => {
  const parameters = {
    ...params,
    query: {
      ...params?.query,
      $modify: 'includeProviderInfos',
    },
  }
  return get<DynamicProductionTimeWithLinkedProviderInfos>(parameters)
}

export const getByProviderWithLinkedProviderInfo = async (provider: ProviderId) => {
  const params = {
    query: {
      provider,
    },
  }
  return getWithLinkedProviderInfo(params)
}

export const create = async (payload: DynamicProductionTimeRequest) =>
  feathersService.create<DynamicProductionTime, DynamicProductionTimeRequest>(RESOURCE, payload)

export const createMultiple = async (payload: DynamicProductionTimeRequest[]) =>
  payload.length > 0
    ? feathersService.createMultiple<DynamicProductionTime, DynamicProductionTimeRequest>(
        RESOURCE,
        payload
      )
    : Promise.resolve([])

export const patch = async (
  payload: Partial<DynamicProductionTimeRequest>,
  id: DynamicProductionTimeId
) => feathersService.patch<DynamicProductionTime>(RESOURCE, id, payload)

export const patchMultiple = async (
  payload: Partial<DynamicProductionTimeRequest>,
  ids: DynamicProductionTimeId[]
) => Promise.all(ids.map(id => patch(payload, id)))

export const remove = async (id: DynamicProductionTimeId) =>
  feathersService.remove<DynamicProductionTime>(RESOURCE, id)

export const removeMultiple = async (ids: DynamicProductionTimeId[]) =>
  Promise.all(ids.map(id => remove(id)))
